import e from "../../../../_virtual/index8.js";
var t = new e(), n = "recharts.syncMouseEvents";
export {
  n as SYNC_EVENT,
  t as eventCenter
};
